
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

/**
 * RedemptionError component
 * Displays an error message and details when redemption information is invalid. Shows PAN card info and provides an edit button.
 */
const RedemptionError = () => {
    return (
        <>
            <div className="container mt-4">
                <div className="row">
                    <div className="col-md-12 pancard-data">
                        <div className="text-center mb-7">
                            <img
                                width="100"
                                alt="icon"
                                src={toAbsoluteUrl("/media/images/invalid.png")}
                            />
                            <h6 className="mt-5">Details  is not Valid</h6>
                        </div>

                        <div className="px-5">
                            <h4 className="mb-5">Details Entered As Per You</h4>
                            <label>PAN Card Number</label>
                            <p>895623147526</p>
                        </div>

                        <div className="btns cn-btn mt-15 d-flex">
                            {/* <Link to={`/customerCard/pan-card/${userId}`}> */}
                            <button type="button" className="btn bgdark-blue text-white">
                                Edit
                            </button>
                            {/* </Link> */}
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default RedemptionError